// Shared visibility check for nav items. Kept out of the pure navConfig (which
// stays free of the auth store) so both consumers — the sidebar NavMenu and the
// horizontal SectionTabs — apply identical permission logic.
import { can } from '../auth/store';
import type { NavItem } from './navConfig';

/**
 * Whether the current user may see a nav item. `perm` is optional (always
 * visible), a single permission, or an array meaning "any of" — visible when
 * the user holds at least one.
 */
export function canSeeNavItem(item: NavItem): boolean {
  if (!item.perm) return true;
  return Array.isArray(item.perm) ? item.perm.some(can) : can(item.perm);
}
